// extracted by mini-css-extract-plugin
module.exports = {"banner":"_b8e17e0","bannerBackground":"_8f1a206"};